import { Endpoints } from "../../contants/endpoints";
import { api } from "../../lib/api";

export async function getCategoryTree(parentId?: string) {
  try {
    const res = await api.get(Endpoints.category.getTree, {
      params: parentId ? { parentId } : {},
    });

    if (res.data) {
      return res.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("API category tree error:", error);
    return [];
  }
}
